import { Component, input } from '@angular/core';
import { RemoveHtmlPipe } from '@shared/pipes/remove-html.pipe';
import { HelperService } from '../../../../services/helper.service';
import { IHome_LatestMeeting } from '@shared/constants/models.const';
import { E_DATE_FORMAT } from '@shared/constants/enums.const';

@Component({
  selector: 'app-meeting-card',
  imports: [
    RemoveHtmlPipe,
  ],
  templateUrl: './meeting-card.component.html',
  styleUrl: './meeting-card.component.scss',
})
export class MeetingCardComponent {
  meetingData = input.required<IHome_LatestMeeting | any>();
  hasDesc = input<boolean>(false);
  isLast = input<boolean>(false);

  protected readonly E_DATE_FORMAT = E_DATE_FORMAT;

  getUrl(): string {
    return this.HELPER.getUrl(this.meetingData().sourceUrl);
  }

  constructor(
    public HELPER: HelperService,
  ) {
  }
}
